import { Grid } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import {
  FormInfoInput,
  ReactFormInput,
  SimpleButton,
  StripeInput,
} from '../../../../components';
import useStyles from '../styles';
import { PaymentMethod } from '../../../../types/items';
import { getPaymentCardString } from '../../../../utility/billing';

type Props = {
  paymentMethod: PaymentMethod | null;
  updateValidState: (bool: boolean) => void;
  useSavedCard: boolean;
  setUseSavedCard: (bool: boolean) => void;
};

const CheckoutCardFields = ({
  paymentMethod,
  updateValidState = () => {},
  useSavedCard,
  setUseSavedCard,
}: Props) => {
  const classes = useStyles();
  const [validCard, setValidCard] = useState(false);
  const [validCVC, setValidCVC] = useState(false);
  const [validExpDate, setValidExpDate] = useState(false);

  useEffect(() => {
    updateValidState(validCard && validCVC && validExpDate);
  }, [validCard, validCVC, validExpDate, updateValidState]);

  return (
    <>
      {(paymentMethod && useSavedCard)
      && (
        <Grid item xs={12}>
          <FormInfoInput
            label="Card Number"
            value={paymentMethod ? getPaymentCardString(paymentMethod) : ''}
            className={classes.fullCardNumberField}
          />
          {useSavedCard
          && (
            <SimpleButton onClick={() => setUseSavedCard(false)}>
              Change Card
            </SimpleButton>
          )}
        </Grid>
      )}

      {!useSavedCard
      && (
        <>
          <Grid item xs={12} sm={6}>
            <StripeInput
              name="card_number"
              label="Card number"
              componentType="card"
              setValidStatus={setValidCard}
            />
          </Grid>
          <Grid item container direction="row" justify="space-between" xs={12} sm={6}>

            <Grid item className={classes.cardField}>
              <StripeInput
                name="expiration_date"
                label="MM/YY"
                componentType="expiration_date"
                setValidStatus={setValidExpDate}
              />
            </Grid>
            <Grid item className={classes.cardField}>
              <StripeInput
                name="cvc"
                label="CVC"
                componentType="cvc"
                setValidStatus={setValidCVC}
              />
            </Grid>
            <Grid item className={classes.cardField}>
              <ReactFormInput
                label="Zip"
                name="zip_code"
                inputProps={{
                  maxLength: 12,
                }}
                hideErrors
              />
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default CheckoutCardFields;
